const mergeTimeRange = (existingTimeRange, nextTimeRange) => {
  if (!nextTimeRange) return existingTimeRange;

  return {
    ...(existingTimeRange || {}),
    ...nextTimeRange,
  };
};

export const mergeEventWithOptimisticPatch = (event, patch) => {
  if (!patch) return event;

  return {
    ...event,
    ...patch,
    timeRange: patch.timeRange
      ? mergeTimeRange(event.timeRange, patch.timeRange)
      : event.timeRange,
  };
};

export const applyOptimisticEventPatch = (state, eventId, patch) => {
  if (!eventId || !patch) return state;

  return {
    ...state,
    [eventId]: {
      ...(state[eventId] || {}),
      ...patch,
      timeRange: patch.timeRange
        ? mergeTimeRange(state[eventId]?.timeRange, patch.timeRange)
        : state[eventId]?.timeRange,
    },
  };
};

export const clearOptimisticEventPatch = (state, eventId) => {
  if (!eventId || !state[eventId]) return state;

  const nextState = { ...state };
  delete nextState[eventId];
  return nextState;
};

export const mergeEventsWithOptimisticPatches = (events = [], patches = {}) =>
  events.map((event) => {
    const eventId = String(event.id || event._id || "");
    const patch = patches[eventId];

    return patch ? mergeEventWithOptimisticPatch(event, patch) : event;
  });
